export default "__VITE_ASSET__CviLhtKw__"